import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { User } from '@src/app/_models/user/user';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { Hotline } from '@src/app/_models/hotline/hotline';
import { registerLocaleData } from '@angular/common';
import { DataService } from '@src/app/_services/data.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import moment from 'moment';
import localeCs from '@angular/common/locales/cs';
import { TabComponent, ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ActivatedRoute, Router } from '@angular/router';
import { ExcelService } from '@src/app/_services/excel.service';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { HotlineCalendarComponent } from '@src/app/features/hotline/components/hotline-calendar/hotline-calendar.component';

moment.updateLocale('cs', { workingWeekdays: [1, 2, 3, 4, 5] });
registerLocaleData(localeCs);

@UntilDestroy()
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToolbarModule, ButtonModule, HotlineCalendarComponent],
})
export class HomeComponent implements OnInit {
    hotlines: Hotline[] = [];

    currentUser: User | null;

    currDate = moment().format('YYYY-MM-DD');

    loadingHotlineWidget = true;

    @ViewChild('hotlineTab') hotlineTabObj?: TabComponent;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly authenticationService: AuthenticationService,
        private readonly dataService: DataService,
        private readonly excelService: ExcelService,
        private readonly ref: ChangeDetectorRef
    ) {
        this.currentUser = this.authenticationService.currentUserValue;
    }

    ngOnInit(): void {
        this.dataService.hotlineSource.pipe(untilDestroyed(this)).subscribe(
            (data: Hotline[]) => {
                this.hotlines = [];
                data.map((hotline: Hotline) => {
                    if (
                        !hotline.deleted_date &&
                        moment(hotline.start_at).format('YYYY-MM-DD') === this.currDate &&
                        moment(hotline.end_at).format('YYYY-MM-DD') === this.currDate
                    ) {
                        this.hotlines.push(hotline);
                    }
                });
                this.loadingHotlineWidget = false;
                this.ref.markForCheck();
            },
            error => {
                console.error(error);
                this.loadingHotlineWidget = false;
                this.ref.markForCheck();
            }
        );

        this.dataService.setHotlinesDataSource();
    }

    navigateToTab(form?: string): void {
        const queryParams = { form };

        void this.router.navigate(['/hotline/list'], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge',
        });
    }
}
